import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import ClientContext from 'app/src/contexts/ClientContext';
import { Loading } from 'app/src/elements/DataState';
import { Title, Text } from 'app/src/styles';

import NewUser from './new';
import EditUser from './edit';
import { USERS } from './queries';

const Users = () => {
  const [showNew, setShowNew] = useState();
  const [showEdit, setShowEdit] = useState();

  const { currentUser } = useContext(ClientContext);

  const { data, refetch } = useQuery(USERS);

  if (!currentUser || !data) { return <Loading />; }

  const columns = [
    {
      key: 'name',
      label: 'Name',
    },
    {
      key: 'email',
      label: 'Email',
      width: 200,
    },
  ];

  const canAdmin =
    currentUser.clientUsers.filter(clientUser => clientUser.admin).length > 0

  currentUser.clientUsers.map(clientUser => {
    const { client } = clientUser;

    columns.push({
      key: client.id,
      label: (currentUser.clientUsers.length > 1 ? client.name : 'Role'),
      sort: 'prevent',
      headerStyle: { maxWidth: 200 },
      value: ({ entry }) => {
        const clientUser = entry.clientUsers.find(user => (
          user.client.id === client.id
        ));

        if (!clientUser) { return ''; }
        if (clientUser.admin) { return 'Admin'; }
        return 'Access';
      }
    });
  });

  if (canAdmin) {
    columns.push({
      key: 'actions',
      label: 'Actions',
      sort: 'prevent',
      content: ({ entry }) => (
        <Pressable onPress={() => setShowEdit(entry)}>
          <Text>Edit</Text>
        </Pressable>
      )
    });
  }

  return (
    <View>
      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <Title style={{ flex: 1 }}>Users</Title>
      </View>

      {canAdmin && (
        <Pressable onPress={() => setShowNew(true)}>
          <Text>Add User</Text>
        </Pressable>
      )}

      <DataTable.Simple
        data={data.users}
        columns={columns}
      />

      {showNew && <NewUser setShow={setShowNew} refetch={refetch} />}

      {showEdit && (
        <EditUser user={showEdit} setShow={setShowEdit} refetch={refetch} />
      )}
    </View>
  );
};

export default Users;
